// src/components/battle/BattleDetailActions.js

import React from "react";

export default function BattleDetailActions({
  canJoin,
  canStart,
  canViewResult,
  showStartButton = true, // ✅ 추가 (기본값 true)
  joining,
  finishing,
  onJoin,
  onStart,
  onViewResult,
}) {
  // 공통 버튼 스타일 (민트 + 화이트 글씨 + 둥근 네모)
  const baseBtn =
    "flex-1 py-3 rounded-2xl text-white font-semibold shadow-sm transition";
  const mintBtn = `${baseBtn} bg-[rgb(0,224,198)] active:opacity-80`;

  return (
    <section className="flex flex-col gap-2 mt-4">
      {/* 참가하기 */}
      {canJoin && (
        <button
          type="button"
          className={mintBtn}
          onClick={onJoin}
          disabled={joining}
        >
          참가하기
        </button>
      )}

      {/* 시작하기 */}
      {showStartButton && canStart && (
        <button
          type="button"
          className={mintBtn}
          onClick={onStart}
          disabled={finishing}
        >
          시작하기
        </button>
      )}

      {/* 결과보기 */}
      {canViewResult && (
        <button
          type="button"
          className={mintBtn}
          onClick={onViewResult}
        >
          결과보기
        </button>
      )}
    </section>
  );
}
